export default "__VITE_ASSET__SF7yRICc__"